module.exports = __webpack_public_path__ + "assets/radio-default.40e0cb01.svg";